import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Loader } from '@mantine/core';
import './IconTextAction.css';

export type IconTextActionVariant = 'default' | 'primary' | 'danger';

export interface IconTextActionProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  icon: ReactNode;
  children: ReactNode;
  loading?: boolean;
  variant?: IconTextActionVariant;
}

export default function IconTextAction({
  icon,
  children,
  loading = false,
  variant = 'default',
  className = '',
  disabled,
  type = 'button',
  ...rest
}: IconTextActionProps) {
  const rootClass = ['icon-text-action', `icon-text-action--${variant}`, className].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={rootClass}
      disabled={disabled || loading}
      {...rest}
    >
      <span className="icon-text-action__icon" aria-hidden>
        {loading ? <Loader size={20} type="oval" color="currentColor" /> : icon}
      </span>
      <span className="icon-text-action__label">{children}</span>
    </button>
  );
}
